import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditPositionWishForCandidateResponse extends BackendResponse {}
export interface EditPositionWishForCandidateParameters extends NextApiParams {
  positionWishId: number;
  positionWishType: number;
  level?: 0 | 1 | 2 | 3;
}

export const editPositionWishForCandidate = withNextApi<
  EditPositionWishForCandidateResponse,
  EditPositionWishForCandidateParameters
>("/cvp/CvpEditPositionWishForCandidate");
